'use client';
import React, { useMemo, useEffect } from 'react';

// Fallback script component to be used if NextJsScriptComponent is not provided
const DefaultScriptComponent = (props) => (React.createElement("script", { ...props }));
const DEFAULT_BREAKPOINT = 980;
/**
 * We decided to inline the script instead of using the classic useEffect
 * to break out of the React.js flow and directly inject the script into the HTML.
 * This approach ensures we don't need to wait for React's lifecycle and the script is available immediately.
 */
const LiraRunAdvScript = ({ NextJsScriptComponent = DefaultScriptComponent, // Use DefaultScriptComponent as fallback
clientSideNavigationStarted, onAfterReloaded, ...configFromConsumerProps }) => {
    // Serializing the config
    const configString = useMemo(() => JSON.stringify(configFromConsumerProps), [configFromConsumerProps]);
    useEffect(() => {
        if (clientSideNavigationStarted) {
            const mediaQueryList = window.matchMedia(`(min-width: ${DEFAULT_BREAKPOINT}px)`);
            const config = {
                ...configFromConsumerProps,
                property: mediaQueryList.matches
                    ? 'desktop'
                    : 'msite',
            };
            window.liraSDKQueue.push(() => {
                window.liraSdk.fetchAdsClientSideNavigation(config);
            });
            onAfterReloaded?.();
        }
    }, [clientSideNavigationStarted, configFromConsumerProps, onAfterReloaded]);
    // Generating the script content
    const scriptContent = `
    (function(configString) {
      if (window.liraScriptExecuted) return;
      window.liraScriptExecuted = true;
      window.liraSDKQueue = window.liraSDKQueue || [];
      window.liraSDKQueue.push(function() {                
        const mediaQueryList = window.matchMedia('(min-width: ${DEFAULT_BREAKPOINT}px)');
        const config = JSON.parse(configString);
        config.property = mediaQueryList.matches ? 'desktop' : 'msite';
        window.liraSdk.fetchAds(config);         
      });
    })('${configString.replace(/'/g, "\\'")}');
  `;
    return (React.createElement(NextJsScriptComponent, { id: "lira-adv-script", dangerouslySetInnerHTML: { __html: scriptContent } }));
};

export { LiraRunAdvScript };
//# sourceMappingURL=index.js.map
